import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Link from 'flarum/common/components/Link';
import { getContrastColor } from '../common';

/**
 * Friend-count badge next to the author's name in a post's header — same
 * `userViewItems` extension point PostUser exposes for Arena's stats
 * badge, so both extensions' badges sit in the same row.
 *
 * String-based extend() is required here, not a direct import — see
 * addFriendUserSettings.tsx's docblock for why (confirmed live crash on
 * 2026-08-31 when this used a direct PostUser import).
 */
export default function addFriendBadgeToPost() {
  extend('flarum/forum/components/PostUser', 'userViewItems', function (items, user) {
    if (!user) return;
    if (app.forum.attribute('friendshipShowBadgeOnPost') === false) return;
    if (user.attribute('friendshipShowInPosts') === false) return;
    const count = user.attribute('friendCount') || 0;
    if (count === 0) return;
    const bgColor = app.forum.attribute('friendshipBadgeBgColor') || '#45698D';
    const icon = app.forum.attribute('friendshipBadgeIcon') || 'fas fa-hand-peace';
    items.add('friendCount', m(Link, {
      href: app.route('user.friendship', {
        username: user.username()
      }),
      className: "Badge FriendshipPostBadge",
      style: {
        background: bgColor,
        color: getContrastColor(bgColor)
      }
    }, m("i", {
      className: icon
    }), m("span", {
      className: "FriendshipPostBadge-count"
    }, count)), 80);
  });
}